var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteWordcloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1688 -232)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1687.181 231.354)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.366 0.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    transform: "translate(0.453 0.453)",
    fill: "#008bff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2455.562 -39.46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4148.562 275.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1,1.548H54.968V1.161A1.161,1.161,0,0,0,53.806,0H52.258A1.161,1.161,0,0,0,51.1,1.161v.387H48.968A.968.968,0,0,0,48,2.516V3.29a.387.387,0,0,0,.387.387h9.29a.387.387,0,0,0,.387-.387V2.516A.968.968,0,0,0,57.1,1.548Zm-5.226-.387a.388.388,0,0,1,.387-.387h1.548a.388.388,0,0,1,.387.387v.387H51.871Z",
    transform: "translate(-48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.485,184a.121.121,0,0,0-.121.127l.319,6.7a1.16,1.16,0,0,0,1.16,1.106h5.878a1.16,1.16,0,0,0,1.16-1.106l.319-6.7A.121.121,0,0,0,82.08,184Zm5.846.968a.387.387,0,1,1,.774,0V190a.387.387,0,1,1-.774,0Zm-1.935,0a.387.387,0,1,1,.774,0V190a.387.387,0,1,1-.774,0Zm-1.935,0a.387.387,0,1,1,.774,0V190a.387.387,0,1,1-.774,0Z",
    transform: "translate(-72.751 -179.549)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWordcloud);
export default __webpack_public_path__ + "static/media/delete-wordcloud.3174e844cb64f124aafb5fb165f06b1c.svg";
export { ForwardRef as ReactComponent };